import { TooltipModal } from "@/components/tooltips/TooltipModal";
import { ComparisonArrayProps, FAQProps, FrontPack, PackTabProps } from "./types";

export const packs: FrontPack[] = [
    {
        image: "/pack-std.png",
        title: "Pack Standard Virtuel Illimité",
        description: "",
        color: "primaryGreen",
    },
    {
        image: "/pack-fixe.png",
        title: "Pack Fixe VoIP Illimité",
        description: "",
        color: "primaryBlue",
    }/* ,
    {
        image: "/pack-business.png",
        title: "Pack Business Pro",
        description: "Je performe",
        color: "primaryBlack",
    }, */
]

export const packTabs: PackTabProps[] = [
    {
        pack: packs[0],
        description: "Activez un Standard Téléphonique Virtuel en 2 minutes sans aucune connaissance technique et recevez vos appels sur vos téléphones fixes et mobiles que vous avez déjà",
        priceMonthly: 14.90,
        priceYearly: 149.00,
        ctaText: "Souscrire",
        type: "commande",
        benefits: [
            "Standard Téléphonique tout compris avec renvoi d’appel vers vos lignes fixes et mobiles",
            "Un numéro local (01, 02, 03, 04, 05), national (09) pour votre entreprise ou conservez le vôtre",
            "Activation 100% en ligne instantanée",
            "Sans engagement",
        ],
        color: packs[0].color,
        secondaryColor: "bg-secondaryGreen",
        textColor: "text-primaryGreen",
        borderColor: "border-primaryGreen",
    },
    {
        pack: packs[1],
        description: "Votre Standard Téléphonique avec appels illimités et application mobile en mobilité et télétravail",
        priceMonthly: 19.90,
        priceYearly: 199.00,
        ctaText: "Souscrire",
        type: "telephonieIp",
        benefits: [
            "Standard Téléphonique Virtuel tout inclus",
            "Un numéro local (01, 02, 03, 04, 05), national (09) pour votre entreprise ou conservez le vôtre",
            "Appels inclus vers Fixes et Mobiles",
            "Application mobile et ordinateur",
            "Activation 100% en ligne instantanée",
            "Sans engagement",
        ],
        color: packs[1].color,
        secondaryColor: "bg-secondaryBlue",
        textColor: "text-primaryBlue",
        borderColor: "border-primaryBlue",
        conditions: true,
    }/* ,
    {
        pack: packs[2],
        description: "Une Box Internet Pro tout compris qui sécurise votre activité et s’adapte à vos besoins",
        priceMonthly: 79.90,
        priceYearly: 79.90,
        ctaText: "Demander un devis",
        cta: () => {
            window.open("https://www.pack-business-pro.fr/", "_blank");
        },
        benefits: [
            "Fibre Pro sécurisée très haut débit jusqu’à 1 Gb/s",
            "Standard Téléphonique Pro",
            "Appels inclus vers Fixes et Mobiles",
            "Application mobile et ordinateur",
            "Assistance et supervision proactive",
        ],
        color: packs[2].color,
        secondaryColor: "bg-secondaryBlack",
        textColor: "text-primaryBlack",
        borderColor: "border-primaryBlack",
        conditions: true,
    } */
]

export const comparisonArray: ComparisonArrayProps = {
    sections: [
        {
            title: "Numéros & utilisateurs",
            lines: [
                {
                    title: "1 numéro fixe par entreprise",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "1 numéro fixe par utilisateur",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Numéros internationaux",
                    standard: {
                        featured: false,
                        content: "Option"
                    },
                    voip: {
                        featured: false,
                        content: "Option"
                    }/* ,
                    pro: {
                        featured: false,
                        content: "Option"
                    } */
                },
                {
                    title: "Utilisateurs illimités",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: false,
                    }/* ,
                    pro: {
                        featured: false,
                    } */
                }
            ]
        },
        {
            title: "Appels",
            lines: [
                {
                    title: "Appels entrants illimités et renvoi d’appels illimité (France métropolitaine & DOM-TOM)",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Appels sortants vers Fixes et Mobiles en France Métropolitaine",
                    tooltip: <TooltipModal text="contenu de la modal a ajouter" />, 
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Redirections d'appels vers destinations internationales",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: false,
                    }/* ,
                    pro: {
                        featured: false,
                    } */
                },
                {
                    title: "Appels sortants vers destinations internationales",
                    tooltip: <TooltipModal text="contenu de la modal a ajouter" />,
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: false,
                    } */
                },
                {
                    title: "Notifications d'appels",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Application mobile et ordinateur",
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Réception de fax par e-mail",
                    standard: {
                        featured: false,
                        content: "Option"
                    },
                    voip: {
                        featured: false,
                        content: "Option"
                    }/* ,
                    pro: {
                        featured: false,
                        content: "Option"
                    } */
                },
            ]
        },
        {
            title: "SMS",
            lines: [
                {
                    title: "Envoie de SMS",
                    standard: {
                        featured: false,
                        content: "Option"
                    },
                    voip: {
                        featured: false,
                        content: "Option"
                    }/* ,
                    pro: {
                        featured: false,
                        content: "Option"
                    } */
                }
            ]
        },
        {
            title: "Standard Téléphonique",
            lines: [
                {
                    title: "Pré-décroché",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Musique d'attente",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Gestion des horaires",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Redirection d'appels",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Menu Multichoix",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "File d'attente",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
            ]
        },
        {
            title: "Suivi statistique",
            lines: [
                {
                    title: "Journal d'appel intéractif",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Enregistrement d'appels",
                    standard: {
                        featured: false,
                        content: "Option"
                    },
                    voip: {
                        featured: false,
                        content: "Option"
                    }/* ,
                    pro: {
                        featured: false,
                        content: "Option"
                    } */
                },
                {
                    title: "Click to call",
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Choix du numéro de téléphone sortant",
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Changement d'appareil en cours de communication",
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Messages vocaux par email",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Statistiques",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                }
            ]
        },
        {
            title: "Outils collaboratifs",
            lines: [
                {
                    title: "Répertoire de contacts partagés entre utilisateurs",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Mode 'Ne pas déranger'",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Sonneries personnalisées",
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Messagerie collaborative",
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Conférence téléphonique",
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                }
            ]
        },
        {
            title: "Intégrations",
            lines: [
                {
                    title: "E-mail",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Intégration CRM natives",
                    standard: {
                        featured: false,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                }
            ]
        },
        {
            title: "Support client",
            lines: [
                {
                    title: "Portabilité de votre numéro historique",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Plateforme d'onboarding",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Support par e-mail et téléphone",
                    standard: {
                        featured: true,
                    },
                    voip: {
                        featured: true,
                    }/* ,
                    pro: {
                        featured: true,
                    } */
                },
                {
                    title: "Responsable de compte dédié",
                    standard: {
                        featured: false,
                        content: "A partir de 20 numéros"
                    },
                    voip: {
                        featured: false,
                        content: "A partir de 20 licences"
                    }/* ,
                    pro: {
                        featured: false,
                        content: "Inclus"
                    } */
                },
                {
                    title: "Documents contractuels",
                    standard: {
                        featured: false,
                        content: <a target="_blank" href="/recap-contrat-pack-standard.pdf">Packs Standard Virtuel Illimité</a>
                    },
                    voip: {
                        featured: false,
                        content: <a target="_blank" href="/recap-contrat-pack-voip.pdf">Packs Fixe VOIP</a>
                    }/* ,
                    pro: {
                        featured: false,
                        content: <a target="_blank" href="/recap-contrat-pack-pro.pdf">Pack Business PRO</a>
                    } */
                }
            ]
        }
    ]
};

export const homeFAQ: FAQProps[] = [
    {
        title: "Qu’est-ce Standard en ligne ?",
        answer: "Standard en ligne est la solution idéale pour les petites et moyennes entreprises qui souhaitent bénéficier d’un Standard Téléphonique facile à utiliser pour pouvoir gérer efficacement ses appels entrants. Il suffit de quelques clics pour choisir un numéro de téléphone, configurer son Standard Téléphonique (Pré-décroché, renvoi d’appels), et commencer recevoir ses premiers appels clients depuis son téléphone mobile, application mobile ou ordinateur, sans aucune connaissance technique. Standard en ligne vous permet de suivre précisément les appels reçus sur votre standard grâce au journal d’appel interactif, l’intégration CRM , les enregistrements d’appels ainsi que les notifications par e-mail d’appels"
    },
    {
        title: "Comment utiliser Standard en ligne ?",
        answer: "Pour utiliser Standard en ligne, rien de plus simple: Il vous suffit d’avoir une ligne fixe ou mobile pour recevoir vos appels sur vos téléphone existants, ou d’un smartphone et un ordinateur pour émettre et recevoir vos appels téléphoniques.",
        conditions: true
    },
    {
        title: "Combien coûte Standard en ligne ?",
        answer: "Standard en ligne est une solution accessible et simple à mettre en place. Standard en ligne propose plusieurs forfaits adaptés à votre besoin et à votre consommation."
    },
    {
        title: "Est-ce que les appels sont inclus dans les offres ?",
        answer: "Oui. Le Pack Standard Virtuel Illimité inclut des appels entrants illimités et un renvoi d’appels illimité vers des lignes fixes et mobiles en France métropolitaine et dans les DOM-TOM. Le Pack Fixe VoIP inclut des appels entrants et sortants selon le forfait Start ou Pro (voir conditions détaillées).",
        conditions: true
    }
]

export const countries = [
    {
      name: "Afrique du Sud",
      code: "ZA",
    },
    {
      name: "Albanie",
      code: "AL",
    },
    {
      name: "Allemagne",
      code: "DE",
    },
    {
      name: "Angola",
      code: "AO",
    },
    {
      name: "Arabie saoudite",
      code: "SA",
    },
    {
      name: "Argentine",
      code: "AR",
    },
    {
      name: "Australie",
      code: "AU",
    },
    {
      name: "Autriche",
      code: "AT",
    },
    {
      name: "Bahreïn",
      code: "BH",
    },
    {
      name: "Bangladesh",
      code: "BD",
    },
    {
      name: "Barbade",
      code: "BB",
    },
    {
      name: "Belgique",
      code: "BE",
    },
    {
      name: "Belize",
      code: "BZ",
    },
    {
      name: "Bénin",
      code: "BJ",
    },
    {
      name: "Bolivie",
      code: "BO",
    },
    {
      name: "Bosnie-Herzégovine",
      code: "BA",
    },
    {
      name: "Brésil",
      code: "BR",
    },
    {
      name: "Bulgarie",
      code: "BG",
    },
    {
      name: "Burkina Faso",
      code: "BF",
    },
    {
      name: "Cambodge",
      code: "KH",
    },
    {
      name: "Cameroun",
      code: "CM",
    },
    {
      name: "Canada",
      code: "CA",
    },
    {
      name: "Chili",
      code: "CL",
    },
    {
      name: "Chine",
      code: "CN",
    },
    {
      name: "Chypre",
      code: "CY",
    },
    {
      name: "Colombie",
      code: "CO",
    },
    {
      name: "Corée du Sud",
      code: "KR",
    },
    {
      name: "Costa Rica",
      code: "CR",
    },
    {
      name: "Côte d'Ivoire",
      code: "CI",
    },
    {
      name: "Croatie",
      code: "HR",
    },
    {
      name: "Danemark",
      code: "DK",
    },
    {
      name: "Égypte",
      code: "EG",
    },
    {
      name: "El Salvador",
      code: "SV",
    },
    {
      name: "Émirats arabes unis",
      code: "AE",
    },
    {
      name: "Équateur",
      code: "EC",
    },
    {
      name: "Espagne",
      code: "ES",
    },
    {
      name: "Estonie",
      code: "EE",
    },
    {
      name: "États-Unis",
      code: "US",
    },
    {
      name: "Finlande",
      code: "FI",
    },
    {
      name: "France",
      code: "FR",
    },
    {
      name: "Géorgie",
      code: "GE",
    },
    {
      name: "Ghana",
      code: "GH",
    },
    {
      name: "Grèce",
      code: "GR",
    },
    {
      name: "Grenade",
      code: "GD",
    },
    {
      name: "Guatemala",
      code: "GT",
    },
    {
      name: "Guinée",
      code: "GN",
    },
    {
      name: "Honduras",
      code: "HN",
    },
    {
      name: "Hong Kong",
      code: "HK",
    },
    {
      name: "Hongrie",
      code: "HU",
    },
    {
      name: "Îles Caïmans",
      code: "KY",
    },
    {
      name: "Inde",
      code: "IN",
    },
    {
      name: "Indonésie",
      code: "ID",
    },
    {
      name: "Irlande",
      code: "IE",
    },
    {
      name: "Islande",
      code: "IS",
    },
    {
      name: "Israël",
      code: "IL",
    },
    {
      name: "Italie",
      code: "IT",
    },
    {
      name: "Jamaïque",
      code: "JM",
    },
    {
      name: "Jordanie",
      code: "JO",
    },
    {
      name: "Kazakhstan",
      code: "KZ",
    },
    {
      name: "Kenya",
      code: "KE",
    },
    {
      name: "Kosovo",
      code: "XK",
    },
    {
      name: "Koweït",
      code: "KW",
    },
    {
      name: "Lettonie",
      code: "LV",
    },
    {
      name: "Lituanie",
      code: "LT",
    },
    {
      name: "Luxembourg",
      code: "LU",
    },
    {
      name: "Macédoine du Nord",
      code: "MK",
    },
    {
      name: "Malaisie",
      code: "MY",
    },
    {
      name: "Malte",
      code: "MT",
    },
    {
      name: "Maroc",
      code: "MA",
    },
    {
      name: "Mexique",
      code: "MX",
    },
    {
      name: "Moldavie",
      code: "MD",
    },
    {
      name: "Monténégro",
      code: "ME",
    },
    {
      name: "Myanmar (Birmanie)",
      code: "MM",
    },
    {
      name: "Nicaragua",
      code: "NI",
    },
    {
      name: "Nigeria",
      code: "NG",
    },
    {
      name: "Norvège",
      code: "NO",
    },
    {
      name: "Nouvelle-Zélande",
      code: "NZ",
    },
    {
      name: "Ouganda",
      code: "UG",
    },
    {
      name: "Ouzbékistan",
      code: "UZ",
    },
    {
      name: "Pakistan",
      code: "PK",
    },
    {
      name: "Panama",
      code: "PA",
    },
    {
      name: "Paraguay",
      code: "PY",
    },
    {
      name: "Pays-Bas",
      code: "NL",
    },
    {
      name: "Pérou",
      code: "PE",
    },
    {
      name: "Philippines",
      code: "PH",
    },
    {
      name: "Pologne",
      code: "PL",
    },
    {
      name: "Porto Rico",
      code: "PR",
    },
    {
      name: "Portugal",
      code: "PT",
    },
    {
      name: "Qatar",
      code: "QA",
    },
    {
      name: "République dominicaine",
      code: "DO",
    },
    {
      name: "République tchèque",
      code: "CZ",
    },
    {
      name: "Roumanie",
      code: "RO",
    },
    {
      name: "Royaume-Uni",
      code: "GB",
    },
    {
      name: "Serbie",
      code: "RS",
    },
    {
      name: "Seychelles",
      code: "SC",
    },
    {
      name: "Singapour",
      code: "SG",
    },
    {
      name: "Slovaquie",
      code: "SK",
    },
    {
      name: "Slovénie",
      code: "SI",
    },
    {
      name: "Sri Lanka",
      code: "LK",
    },
    {
      name: "Suède",
      code: "SE",
    },
    {
      name: "Suisse",
      code: "CH",
    },
    {
      name: "Taïwan",
      code: "TW",
    },
    {
      name: "Thaïlande",
      code: "TH",
    },
    {
      name: "Trinité-et-Tobago",
      code: "TT",
    },
    {
      name: "Tunisie",
      code: "TN",
    },
    {
      name: "Ukraine",
      code: "UA",
    },
    {
      name: "Uruguay",
      code: "UY",
    },
    {
      name: "Venezuela",
      code: "VE",
    },
    {
      name: "Vietnam",
      code: "VN",
    },
    {
      name: "Zimbabwe",
      code: "ZW",
    },
  ];

// List of countries without the countries in the database
export const countriesCleaned = [
    {
      name: "France",
      code: "FR",
    },
    {
      name: "Belgique",
      code: "BE",
    },
    {
      name: "Canada",
      code: "CA",
    },
    {
      name: "Danemark",
      code: "DK",
    },
    {
      name: "Espagne",
      code: "ES",
    },
    {
      name: "Etats-Unis",
      code: "US",
    },
    {
      name: "Irlande",
      code: "IE",
    },
    {
      name: "Italie",
      code: "IT",
    },
    {
      name: "Pays-Bas",
      code: "NL",
    },
    {
      name: "Royaume Uni",
      code: "GB",
    },
    {
      name: "Suisse",
      code: "CH",
    },
  ];